import styled from 'libs/styled';

const Rect = styled('rect')``;

export default Rect;
